import { ethers } from 'ethers'

import css from 'styles/showcase.module.css'
import { opensea } from 'assets'
import { openseaHref, revealedImageURL, hiddenImageURL } from 'utils'
import { Account, ContractData } from 'types'

type Props = {
  account: Account
  contractData: ContractData
}

export default function Showcase({ account, contractData }: Props) {
  return (
    <div className="mt pd">
      <h2 className={css.title}>SHOWCASE</h2>
      <div className={css.header}>
        <p>
          Maup NFT Collection: <br />
          {contractData.balanceOf
            ? `You own ${contractData.balanceOf} Maups 🐵 ${
                !contractData.revealed ? '(NOT REVEALED YET)' : ''
              }`
            : account
            ? "Looks like You own 0 Maups. What's up... 🤔"
            : 'Connect Wallet to see Your Collection'}
        </p>
        <a
          href={openseaHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="opensea logo"
        >
          <div className={css.opensea}>
            <img
              className="svg"
              src={opensea}
              width={48}
              height={48}
              alt="opensea logo"
            />
          </div>
        </a>
      </div>
      <div className={`${css.collection} mt`}>
        {+contractData.balanceOf > 0 && contractData.walletOfOwner ? (
          <DisplayNFTs contractData={contractData} />
        ) : (
          Array.from({ length: 6 }, (_, i) => (
            <div className={css.empty} key={'maup' + i}>
              <img
                className={css.image_empty}
                width="100%"
                src={require(`assets/mint.png`)}
                alt="hidden maup"
              />
            </div>
          ))
        )}
      </div>
    </div>
  )
}

function DisplayNFTs({ contractData }: { contractData: ContractData }) {
  let _length = 6 - (+contractData.balanceOf % 6)
  return (
    <>
      {contractData.walletOfOwner.map((imageIndex: any, i: number) => (
        <div key={'maup' + i}>
          <img
            className={css.image}
            width="100%"
            src={
              contractData.revealed
                ? `${revealedImageURL}${ethers.BigNumber.from(
                    imageIndex._hex
                  )}.png`
                : hiddenImageURL
            }
            alt={`ape nr.${ethers.BigNumber.from(imageIndex._hex)}`}
          />
        </div>
      ))}
      {Array.from({ length: _length }, (_, i) => (
        <div className={css.empty} key={i}>
          <img
            className={css.image_empty}
            width="100%"
            src={require(`assets/mint.png`)}
            alt="hidden maup"
          />
        </div>
      ))}
    </>
  )
}
